<div class="chartContainer">
    <canvas baseChart *ngIf="isLoaded" [datasets]="mixedChartData" [labels]="barChartLabels" [options]="barChartOptions"
        [plugins]="barChartPlugins" [legend]="barChartLegend" [type]="barChartType">
    </canvas>
</div>